import {SnackMessage} from './snack-message.model';
import {Subject} from 'rxjs/Subject';

export class SnackMessageService {

  private messages: SnackMessage[] = [];
  public newMessage: Subject<SnackMessage> = new Subject<SnackMessage>();

  constructor() {
    this.newMessage.subscribe(
      (snackMessage: SnackMessage) => {
        this.messages.push(snackMessage);
      }
    );
  }

  showDangerFromError(error: any): void {
    const text = SnackMessageService.resolveApiErrorText(error);
    this.newMessage.next(new SnackMessage('danger', text));
  }

  static resolveApiErrorText(error: any): string {
    if (error == null) {
      return 'ERROR';
    }
    if (typeof error === 'string') {
      return error;
    }
    if (error.content != null && String(error.content).length > 0) {
      return String(error.content);
    }
    if (error.body != null && error.body.message != null && String(error.body.message).length > 0) {
      return String(error.body.message);
    }
    if (error.responseMessage != null && String(error.responseMessage).length > 0) {
      return String(error.responseMessage);
    }
    if (error.message != null && String(error.message).length > 0) {
      return String(error.message);
    }
    if (error.error != null) {
      if (typeof error.error === 'string' && error.error.length > 0) {
        return error.error;
      }
      if (error.error.message != null && String(error.error.message).length > 0) {
        return String(error.error.message);
      }
    }
    return 'ERROR';
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/snack-messages/snack-message.service.ts